/**
 * The phone marker (docs/mobile-editor-layout-spec.md 13.1): one tap steps
 * off, colour 1, colour 2, through to the last colour, then off. Off always
 * leads to colour 1, whatever colour was last used, so after the eraser or a
 * full cycle the next tap starts again at the first colour. Pure, for unit tests.
 */
export type MarkerTool = 'brush' | 'eraser' | 'none';

export function nextMarker<C>(tool: MarkerTool, color: C, palette: readonly C[]): { tool: MarkerTool; color: C } {
  if (tool !== 'brush') return { tool: 'brush', color: palette[0] };
  const i = palette.indexOf(color);
  if (i < 0 || i >= palette.length - 1) return { tool: 'none', color: palette[0] };
  return { tool: 'brush', color: palette[i + 1] };
}
